import {createSelector} from '@reduxjs/toolkit';
import {selectDomain} from '.';

export default createSelector([selectDomain], domain => {
  const selected = domain.selectedSuppliers;

  return Object.keys(domain.selectedSuppliers).filter(id => !!selected[id]?.id)
    .length;
});
